
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Toaster/Toaster.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Toaster.html');
        
        var script = require('./Toaster.ts').default;
        module.exports = require('./Toaster.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    